export default __webpack_public_path__ + "static/media/Sanitary Design Industries.b202b0c7.png";